<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}
const browser={
    versions:function(){ 
           const u = navigator.userAgent; 
           return {//移动终端浏览器版本信息 
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad  
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 
                qq: u.match(/\sQQ/i) == " qq" //是否QQ
            };
         }(),
         language:(navigator.browserLanguage || navigator.language).toLowerCase()
} 
 
if(browser.versions.mobile || browser.versions.ios || browser.versions.android || 
  browser.versions.iPhone || browser.versions.iPad){  
    if(window.location.href.indexOf('/detail?')>-1){
      window.location = "/mobile/#/newsDetail?id="+getQueryVariable('id');
    }else{
      window.location = "/mobile/";
    }
}
export default {
    async beforeMount() {
      if(localStorage.getItem('ifm_token')){
        this.$store.dispatch('UPDATE_USERINFO',this.$http);
      }
      this.$http.get('/api/index/getGlobalConfig').then(res2 => {
        if(res2){
            this.$store.commit('UPDATE_INFO', res2);
            if (res2['website_backgroud'] && res2['website_backgroud'].content) {
                document.getElementsByTagName('html')[0].style.filter = res2['website_backgroud'].content;
            }
        }
      })
      this.$http.get('/api/index/getNewsList',{page:1,limit:4}).then(res => {
        if(res){
          this.$store.commit('CHANGE_STATE',{newNews:res.list});
        }
      })
      this.$http.get('/api/index/getNavNodes',{nodeName:'联系我们'}).then(res => {
        if(res){
          this.$store.commit('CHANGE_STATE',{contactObj:res[0]});
        }
      })
      // 获取关于协会
      this.$http.get('/api/index/getNavNodes',{nodeName:'关于协会'}).then(res => {
        if(res){
          let obj = {};
          res.forEach(item => {
              if(item.title === 'IFM简介'){
                  item.url = '/ifmDesc'
                  obj.jianjie = item;
              }else if(item.title === 'IFM在中国'){
                  item.url = '/ifmInChina'
                  obj.zaizhongguo = item;
              }else if(item.title === '理事会成员'){
                  item.url = '/ifmLishihui'
                  obj.lishihui = item;
              }else{
                item.url = '/ifmGrop'
                obj.zjtd = item;
              }
          })
          this.$store.commit('CHANGE_STATE',{aboutxiehuiObj:obj});
        }
      })
      // IFM考试
      this.$http.get('/api/index/getNavNodes',{nodeName:'IFM考试'}).then(res => {
        if(res){
          let obj = {};
          res.forEach(item => {
              if(item.title === '业界评价'){
                  item.url = '/industryEvaluation';
                  obj.yjpj = item;
              }else if(item.title === '补考安排'){
                  item.url = '/makeup';
                  obj.bkap = item;
              }else if(item.title === '认证管理制度'){
                  item.url = '/manageSystem';
                  obj.rzglzd = item;
              }else{
                  item.url = '/qualificationTest'; 
                  obj.zyzgks = item;
              }
          })
          this.$store.commit('CHANGE_STATE',{ifmExamObj:obj});
        }
      })
    },
    mounted() {
      console.log(window.innerHeight);
    },
}
</script>

<style>
#app {
  font-family: "Microsoft YaHei","微软雅黑" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
  box-sizing: border-box;
}
</style>
